export const mobileNavBarData = {
    accounting: [
        { id: 'home', title: 'all.menu.home', path: '/accounting', icon: 'home' },
        { id: 'journals', title: 'accounting.menu.journals', path: '/accounting/journal', icon: 'paper' },
        { id: 'balance', title: 'accounting.menu.balance', path: '/accounting/balance', icon: 'money' },
        { id: 'vatReturn', title: 'accounting.menu.vatReturn', path: '/accounting/vat-return', icon: 'money' },
        { id: 'settings', title: 'accounting.menu.settings', path: '/accounting/settings', icon: 'gear' }
    ],
    admin: [
        { id: 'employees', title: 'admin.menu.employees', path: '/admin/employee', icon: 'people' },
        { id: 'organizations', title: 'admin.menu.organizations', path: '/admin/organization', icon: 'org' },
        { id: 'users', title: 'admin.menu.users', path: '/admin/user', icon: 'people' },
        { id: 'portals', title: 'admin.menu.portals', path: '/admin/portals', icon: 'peopleGroup' }
    ],
    bank: [
        {
            id: 'home',
            title: 'all.menu.home',
            path: '/bank',
            icon: 'home'
        },
        {
            id: 'accounts',
            title: 'bank.menu.accounts',
            path: '/bank/account',
            icon: 'bank'
        },
    ],
    crm: [
        {
            id: 'home',
            title: 'all.menu.home',
            path: '/crm',
            icon: 'home'
        },
        {
            id: 'contacts',
            title: 'crm.menu.contacts',
            path: '/crm/contact',
            icon: 'people',
        },
        {
            id: 'campaigns',
            title: 'crm.menu.campaign',
            path: '/crm/campaign',
            icon: 'megaphone',
        },
        {
            id: 'groups',
            title: 'crm.menu.customerGroup',
            path: '/crm/customerGroup',
            icon: 'peopleGroup',
        }
    ],
    customerPortal: [
        { id: 'invoices', title: 'portal.nav.invoices', path: 'invoice', icon: 'invoice' },
        { id: 'creditNotes', title: 'portal.nav.creditNotes', path: 'creditNote', icon: 'peopleGroup' }
    ],
    documents: [
        { id: 'overview', title: 'all.menu.overview', path: '/documents', icon: 'home' },
        { id: 'browse', title: 'documents.menu.browser', path: '/documents/browser', icon: 'folder' },
        { id: 'allDocuments', title: 'documents.menu.allDocuments', path: '/documents/document', icon: 'document' },
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' }
    ],
    home: [
        {
            id: 'apps',
            title: 'home.menu.apps',
            icon: 'home',
            path: '/home/apps'
        },
        {
            id: 'settings',
            title: 'home.menu.settings',
            icon: 'gear',
            path: '/home/settings'
        }
    ],
    inventory: [
        {
            id: 'home',
            title: 'all.menu.home',
            path: '/inventory',
            icon: 'home'
        },
        {
            id: 'products',
            title: 'inventory.menu.products',
            path: '/inventory/product',
            icon: 'boxes',
        },
        {
            id: 'movements',
            title: 'inventory.menu.movements',
            path: '/inventory/movement',
            icon: 'stockMovement'
        },
        {
            id: 'adjustments',
            title: 'inventory.menu.adjustments',
            path: '/inventory/adjustment',
            icon: 'stockAdjustment',
        }
    ],
    invitation: [
        { id: 'acceptInvitation', title: 'portal.nav.accept', path: 'accept', icon: 'peopleGroup' }
    ],
    joinOrganization: [],
    manufacturing: [
        { id: 'overview', title: 'all.menu.overview', path: '/manufacturing', icon: 'home' },
        { id: 'workOrders', title: 'manufacturing.menu.workOrders', path: '/manufacturing/workOrder', icon: 'task' },
        { id: 'queue', title: 'workExecution.menu.queue', path: '/manufacturing/queue', icon: 'play' },
        { id: 'qualityControl', title: 'manufacturing.menu.qualityChecks', path: '/manufacturing/qualityCheck', icon: 'checkMark' },
        { id: 'workCenters', title: 'manufacturing.menu.workCenters', path: '/manufacturing/workCenter', icon: 'warehouse' },
    ],
    org:[],
    project: [
        { id: 'projects', title: 'project.menu.projects', path: '/project/project', icon: 'task' },
        { id: 'taskBoard', title: 'project.menu.kanban', path: '/project/kanban', icon: 'kanban' },
        { id: 'team', title: 'project.menu.team', path: '/project/team', icon: 'people' },
        { id: 'overview', title: 'all.menu.overview', path: '/project', icon: 'home' }
    ],
    purchases: [
        { id: 'overview', title: 'all.menu.overview', path: '/purchases', icon: 'home' },
        { id: 'inbox', title: 'purchases.menu.inbox', path: '/purchases/inbox', icon: 'inbox' },
        { id: 'purchaseOrders', title: 'purchases.menu.purchaseOrders', path: '/purchases/purchaseOrder', icon: 'invoice' },
        { id: 'expenses', title: 'purchases.menu.expenses', path: '/purchases/expense', icon: 'invoice' },
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' }
    ],
    resetPassword: [],
    sales: [
        {
            id: 'home',
            title: 'sales.menu.home',
            path: '/sales',
            icon: 'home'
        },
        {
            id: 'invoices',
            title: 'sales.menu.invoices',
            path: '/sales/invoice',
            icon: 'invoice',
        },
        {
            id: 'contacts',
            title: 'sales.menu.contacts',
            path: '/sales/contact',
            icon: 'people',
        },
        {
            id: 'products',
            title: 'sales.menu.products',
            path: '/sales/product',
            icon: 'boxes',
        }
    ],
    service: [
        { id: 'overview', title: 'all.menu.overview', path: '/service', icon: 'home' },
        { id: 'tickets', title: 'service.menu.tickets', path: '/service/serviceTicket', icon: 'task' },
        { id: 'workOrders', title: 'service.menu.workOrders', path: '/service/serviceWorkOrder', icon: 'checkMark' },
        { id: 'assets', title: 'service.menu.assets', path: '/service/asset', icon: 'factory' },
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' }
    ],
    studio: [
        { id: 'overview', title: 'studio.menu.overview', path: '/studio', icon: 'home' },
        { id: 'fields', title: 'studio.menu.fields', path: '/studio/field', icon: 'plus' },
        { id: 'overlays', title: 'studio.menu.overlays', path: '/studio/overlay', icon: 'sliders' },
        { id: 'versions', title: 'studio.menu.versions', path: '/studio/version', icon: 'sync' },
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' }
    ],
    supplierPortal: [
        { id: 'orders', title: 'portal.nav.orders', path: 'orders', icon: 'stockMovement' }
    ],
    warehouse: [
        { id: 'overview', title: 'all.menu.overview', path: '/warehouse', icon: 'home' },
        { id: 'releasedOrders', title: 'warehouse.menu.open', path: '/warehouse/warehouseOrder/released', icon: 'task' },
        { id: 'sitesMap', title: 'warehouse.menu.sitesMap', path: '/warehouse/site', icon: 'world' },
        { id: 'warehouseLayout', title: 'warehouse.menu.layout', path: '/warehouse/layout', icon: 'design' },
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
    ]
}